export const APPLY_DISCOUNT_FORM_ID = 'apply-discount-form';

export const OVERRIDE_RATES_SECTION_HEADER_TEST_ID = 'override-rates-section-header';
export const OVERRIDE_RATES_EDIT_PRODUCT_RATES_FORM_TEST_ID = 'override-rates-edit-product-rates-form';
export const OVERRIDE_RATES_DISCOUNT_PANEL_TEST_ID = 'override-rates-discount-panel';
export const OVERRIDE_RATES_RESTORE_RATES_BUTTON_TEST_ID = 'override-rates-restore-rates-button';
export const OVERRIDE_RATES_SECTION_TEST_ID = 'override-rates-section';
